import Api from '../api';
import {LOGIN, LOGIN_URL} from '../lib/constant';
import {addToLocalStorage} from '../lib/utils';

export function loginRequest(param){
  // Transform field names: userIdMobile -> username for the new API
  const apiParam = {
    username: param.userIdMobile,
    password: param.password
  };
  const request = Api.post(LOGIN_URL, apiParam, false);
  return (dispatch) => {
    request.then(({data}) => {
      // API returns: { success: true, data: { token, refreshToken, expiresIn, user: {...} } }
      if (data.success && data.data) {
        // Flatten user data for localStorage compatibility
        // Determine role from roles array - prioritize admin roles
        const roles = data.data.user?.roles || [];
        let role = 'user';
        if (roles.includes('admin') || roles.includes('tenant_owner')) {
          role = 'admin';
        } else if (roles.includes('admin_agent')) {
          role = 'admin_agent';
        } else if (roles.includes('support_agent')) {
          role = 'support_agent';
        } else if (roles.length > 0) {
          role = roles[0];
        }

        const storageData = {
          token: data.data.token,
          refreshToken: data.data.refreshToken,
          userId: data.data.user?.id || '',
          tenantId: data.data.user?.tenantId || '',
          username: data.data.user?.username || '',
          accountStatus: data.data.user?.accountStatus || '',
          role: role,
          roles: roles // Also store full roles array for future use
        };
        addToLocalStorage(storageData);
      }
      dispatch({type:LOGIN, payload:data});
    }).catch(error => {
      dispatch({type:LOGIN, payload: {
        success: false,
        message: error?.response?.data?.message || 'Login failed'
      }});
    })
  };
}
